<script lang='ts'>

	import type { TeaserContent } from '../../../domain/teaser/TeaserContent.ts';
	import { toSignUpSheet } from '../../../domain/SheetData.ts';
	import { TeaserType } from '../../../domain/teaser/TeaserType.ts';
	import { trackClick, trackSeen, trackView } from '../../../services/tracking/TeaserTracking.ts';
	import { onMount } from 'svelte';
	import TrackingService from '../../../services/tracking/TrackingService.ts';
	import { onViewport } from '../../../services/tracking/IntersectionObserver';

	let { teaserContent, backgroundColor = 'stacked', classes = undefined, teaserType }: {
		teaserContent: TeaserContent,
		backgroundColor?: 'canvas' | 'stacked',
		classes?: string,
		teaserType: TeaserType
	} = $props();

	const backgroundColorMap = {
		canvas: '#FFFFFF',
		stacked: '#F0F0F0'
	};


	const resolvedBackgroundColor = backgroundColorMap[backgroundColor] ?? backgroundColorMap['canvas'];

	let teaser: Element;
	const teaserSize = 'MediaObject50';

	let headline = $state(teaserContent.heading);
	const signUpSheetData: string = getSheetData();

	function getSheetData() {
		return JSON.stringify(toSignUpSheet(teaserType, teaserContent, undefined));
	}

	let trackingService: TrackingService;

	onMount(() => {
		trackingService = new TrackingService();

		trackClick(trackingService, teaser, teaserContent, teaserType, teaserSize);
		trackView(trackingService, teaser, teaserContent, teaserType, teaserSize);
	});
</script>

<div bind:this={teaser}
	class="{classes}"
	data-oc-sheet-v1-create={signUpSheetData}
	data-testid="up-booster-teaser-m-container"
	id="teaser-container"
	onenterViewport={() => trackSeen(trackingService)}
	use:onViewport>
	<oc-media-object-card-v2
		data-testid="to-booster-teaser-card"
		as-button=""
		variant="ambient-image"
		style="--background-color: {resolvedBackgroundColor};"
		size="50"
		elevation-level="stacked"
		oc-aria-label="Wechsel auf OTTO UP Plus"
	>
		<picture slot="img">
			<img
				loading="eager"
				src="https:/*                                                                                         */
				aria-hidden="true"
				alt="Gift illustration"
			/>
		</picture>
		<div id="headline" slot="headline">{headline}</div>
		<div id="subline" slot="subline">{teaserContent?.subheading}</div>
		<oc-action-signifier-v1 slot="action-signifier" variant="icon" />
	</oc-media-object-card-v2>
</div>
